
import { Component, Vue } from 'vue-property-decorator'

import authModule from '@/store/auth'
import companyModule from '@/store/company'
import { TextFieldRules } from '@/utils/enums'
import { User } from '@/types/User'

@Component({
  name: 'UserEditor'
})
class UserEditor extends Vue {
  private rules = TextFieldRules
  private oldPassword = ''
  private newPassword = ''
  private rePassword = ''

  private localUser: Partial<User> = {
    firstName: '',
    lastName: '',
    email: ''
  }

  private get user() {
    return authModule.user!
  }

  private get userTitle() {
    return this.user.firstName && this.user.lastName
      ? `${this.user.firstName} ${this.user.lastName}`
      : this.user.email
  }

  private get company() {
    return companyModule.company
  }

  private created() {
    this.localUser.email = this.user.email
    this.localUser.firstName = this.user.firstName
    this.localUser.lastName = this.user.lastName
  }

  private async updateProfile() {
    await authModule.updateProfile({
      whitelabel: this.user.whitelabel.slug!,
      user: this.localUser
    })
    this.$emit('updateProfile')
    document.dispatchEvent(new Event('close-partner'))
    document.dispatchEvent(new Event('close-admin'))
  }

  private async updatePassword() {
    await authModule.updatePassword({
      whitelabel: this.user.whitelabel.slug!,
      password: {
        oldPassword: this.oldPassword,
        newPassword: this.newPassword
      }
    })
    this.$emit('updatePassword')
    document.dispatchEvent(new Event('close-passwort'))
  }
}

export default UserEditor
